document.addEventListener('DOMContentLoaded', () => {
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

  for (const root of document.querySelectorAll('[data-rfm-reviews]')) {
    const track = root.querySelector('[data-rfm-track]');
    const count = root.querySelector('[data-rfm-count]');
    const [prev, next] = root.querySelectorAll('[data-rfm-step]');
    const cards = [...track.children];
    let active = 0;

    const offset = (card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left;

    const sync = () => {
      active = cards.reduce((best, card, i) => (Math.abs(offset(card)) < Math.abs(offset(cards[best])) ? i : best), 0);
      prev.disabled = active === 0;
      next.disabled = active === cards.length - 1;
      count.textContent = `${active + 1} / ${cards.length}`;
    };

    root.addEventListener('click', ({ target }) => {
      const button = target.closest('[data-rfm-step]');
      if (!button) return;
      const index = Math.max(0, Math.min(cards.length - 1, active + Number(button.dataset.rfmStep)));
      track.scrollTo({ left: track.scrollLeft + offset(cards[index]), behavior });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
  }
});
